import { ExternalLabelInput } from '@components/TextField/ExternalLabelInput';
import { UNSAVED_CHANGES_KEYS, setUnsavedChanges } from '@store/unsavedChanges';
import { createEffect, createSignal, onCleanup } from 'solid-js';
import { CarrierAutoCompleteModel } from '@typeDefinitions/carrierTypes';
import type { ChangeTrackingSource } from '@typeDefinitions/changeTrackingTypes';

import { CarrierAutocomplete } from './CarrierAutocomplete';
import { isLoadAvailable, submitBid } from './helpers';

export const SubmitBid = (props: {
  changeTrackingSource?: ChangeTrackingSource;
}) => {
  const [bidAmount, setBidAmount] = createSignal<string | null>(null);
  const [loading, setLoading] = createSignal<boolean>(false);
  const [carrier, setCarrier] = createSignal<CarrierAutoCompleteModel | null>(
    null,
  );
  const [clear, setClear] = createSignal(false);

  createEffect(() => {
    setUnsavedChanges(
      UNSAVED_CHANGES_KEYS.submitBid,
      Boolean(carrier()?.id) || (bidAmount() ?? '') !== '',
    );
  });

  onCleanup(() => {
    setUnsavedChanges(UNSAVED_CHANGES_KEYS.submitBid, false);
  });

  const reset = () => {
    setClear(true);
    setCarrier(null);
    setBidAmount(null);
    setClear(false);
  };
  return (
    <div class="bg-white px-4 py-2" id="submit-new-bid">
      <div class="text-sm text-black font-semibold  ">Submit New Bid</div>
      <div class="flex gap-2 justify-between my-2">
        <div class="w-1/2">
          <CarrierAutocomplete
            label="Search Carrier"
            placeholder="Type to search carriers..."
            clear={clear()}
            onSelect={(option) => {
              setCarrier(option);
            }}
          />
        </div>
        <div class="w-1/2">
          <div class="text-sm text-gray-500 font-medium">Bid Amount</div>
          <ExternalLabelInput
            value={bidAmount() ?? ''}
            type="number"
            placeholder="Enter bid amount"
            onInput={(e: { target: { value: string } }) => {
              setBidAmount(e.target.value);
            }}
          />
        </div>
      </div>
      <div class="flex justify-between gap-2">
        <div class="w-1/2 ">
          <button
            class="bg-gray-200 text-armstrong-primary px-4 py-2 rounded-md w-full"
            onClick={() => {
              reset();
            }}
          >
            Clear
          </button>
        </div>
        <div class="w-1/2 ">
          <button
            class="bg-armstrong-blue text-white px-4 py-2 rounded-md w-full disabled:opacity-20 disabled:pointer-events-none"
            disabled={
              !carrier()?.id || !bidAmount() || !isLoadAvailable() || loading()
            }
            onClick={async () => {
              setLoading(true);
              const amount = Number(bidAmount());
              if (carrier()?.id && amount) {
                await submitBid(carrier()!, amount, props.changeTrackingSource);
                reset();
              }
              setLoading(false);
            }}
          >
            Submit Bid
          </button>
        </div>
      </div>
    </div>
  );
};
